import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[autoFocus]',
  standalone: true
})
export class AutofocusDirective implements AfterViewInit{

  constructor(
    private elementRef: ElementRef
  ) { }

  ngAfterViewInit(){
    setTimeout( () => {
      this.elementRef.nativeElement.focus();
    },200);
  }
}
